'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var createError = exports.createError = function createError() {
  var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'unknown error';
  var desc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '未知错误';

  var err = new Error(msg);
  err.desc = desc;

  return err;
};

var throwError = exports.throwError = function throwError(msg, desc) {
  throw createError(msg, desc);
};

var redirectTo = exports.redirectTo = function redirectTo(dest, qs) {
  var p = location.pathname = '/' + dest;

  if (location.pathname === p) {
    return;
  }

  if (qs) {
    location.href = encodeURI(location.origin + p + '?' + qs);
  } else {
    location.pathname = p;
  }
};

var redirect = exports.redirect = function redirect(pathname) {
  // TODO

  var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
};

var commafy = exports.commafy = function commafy(num) {
  num = num + '';
  var re = /(-?\d+)(\d{3})/;

  while (re.test(num)) {
    num = num.replace(re, '$1,$2');
  }

  return num;
};

var centToYuan = exports.centToYuan = function centToYuan(cent) {
  return cent / 100 | 0;
};

var isTel = exports.isTel = function isTel(tel) {
  var m = String(tel);

  if (/^(\+?0?86\-?)?1[345789]\d{9}$/.test(m)) {
    // 手机
    return true;
  }

  if (/^(400|800)\d{7}$/.test(m)) {
    return true;
  }

  if (/^(9510|1010)\d{4}$/.test(m)) {
    return true;
  }

  if (/^0([0-9]){6,12}$/.test(m)) {
    // 座机 以 0 开始 (必须加区号)
    return true;
  }

  return false;
};

var getUKey = exports.getUKey = function getUKey() {
  return String(Date.now()).slice(7) + '-' + uuid();
};

var toArray = exports.toArray = function toArray(i) {
  return [].concat(i);
};

var includesBigUnicode = exports.includesBigUnicode = function includesBigUnicode(s) {
  s = String(s);

  return [].concat(_toConsumableArray(s)).length !== s.length;
};

/**
 * private
 */
function uuid() {
  var length = 16;
  var hexDigits = '0123456789abcdef';
  var s = parseInt(String(Math.random()).slice(2)).toString('16').split('').slice(0, length);

  s[length - 3] = hexDigits.substr(s[length - 3] & 0x3 | 0x8, 1);

  return s.join('');
}